<template>
  <v-card :elevation="1"
          rounded="lg"
          class="pa-4"
          style="height:100%; width:100%; overflow: scroll">
    <div class="font-weight-bold text-lg">
      {{ conf.title }}
      <span
          class="font-weight-medium grey--text text--lighten-1"> {{
          _formatDate(new Date(),'dd/MM/yyyy')
        }}</span>
    </div>
    <v-data-table class="mt-3"
                  :loading="items.length < 1 && loading"
                  :headers="headers"
                  :items="items"
                  search-field="name"
                  item-key="name"
                  hide-default-footer
                  v-if="items.length > 0"
    >
      <template v-slot:body="{ items }">
        <tbody>
        <tr
            v-for="item in items"
            :key="item.name"
        >
          <td class="">{{ item.siteName }}</td>
          <td class="text-right">
            <div class="d-flex flex-column"
            :class="item.cancelBookingPrice>0? 'red--text':''">
              {{_formatCurrency(item.cancelBookingPrice > 0?-item.cancelBookingPrice:item.cancelBookingPrice, "EUR") }}
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column "
            :class="item.optionFailedPrice>0? 'red--text':''">
              {{ _formatCurrency(item.optionFailedPrice>0 ?-item.optionFailedPrice:item.optionFailedPrice, "EUR") }}
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column"
            :class="item.requestCancelled>0? 'red--text':''">
              {{ _formatCurrency(item.requestCancelled>0?-item.requestCancelled:item.requestCancelled, "EUR") }}
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column"
            :class="item.bookingBooked>0?'green--text':''">
              {{ _formatCurrency(item.bookingBooked, "EUR") }}
            </div>
          </td>
          <td class="text-right">
            <div class="d-flex flex-column"
            :class="item.option>0?'green--text':''">
               {{ _formatCurrency(item.option, "EUR") }}
            </div>
          </td>
        </tr>
        </tbody>

      </template>


    </v-data-table>
  </v-card>
</template>
<script>
import {EventBus} from "@/components/commons/event-bus";
import {get, post} from "@/utils/api";
import {addDays} from "date-fns";
// Détails CA par site
export default {
  name: "WidgetDetailsCA",

  data() {
    return {
      loading: false,
      items: [],
      headers: [
        {
          text: "Site",
          value: "siteName",
          align: "left",
          sortable: false,
        },
        {
          text: "Annulations Client",
          value: "cancelBookingPrice",
          align: "right",
          sortable: false,
        },
        {
          text: "Options tombées",
          value: "optionFailedPrice",
          align: "right",
          sortable: false,
        },
        {
          text: "Annulations stopsell",
          value: "requestCancelled",
          align: "right",
          sortable: false,
        },
        {
          text: "Résas",
          value: "bookingBooked",
          align: "right",
          sortable: false,
        },
        {
          text: "Options en cours",
          value: "option",
          align: "right",
          sortable: false,
        }],
      url: `/api/widget/dashboard/ca/site/details`,
      totaux: {},
      totauxPast: {}
    }
  },
  props: {
    form: {type: Object, required: true},
    conf: {type: Object, required: false, default: null}
  },
  created() {
    this.init()
    EventBus.$on('searchDashboard', () => this.init());
  },
  computed: {},
  methods: {
    init() {
      const body = {
        startDateAct: this._formatDate(new Date(), 'yyyy-MM-dd'),
        stopDateAct:  this._formatDate(new Date(), 'yyyy-MM-dd'),
        startDateOld: this._formatDate(new Date(), 'yyyy-MM-dd'),
        stopDateOld:  this._formatDate(new Date(), 'yyyy-MM-dd'),
        destinations: [],
        sites: [],
        commercialIds: [],
        allAgencies: false,
        bookingStatus: null
      }
      this.items = []
      post(this.url, body, {"Content-Type": "application/json"})
          .json(r => {
            this.items.push(...r, this.getTotal(r))
            console.log(this.items)
          })
    },
    sum(accumulator, a) {
      return accumulator + a;
    },
    getTotal(list) {

      return {
        siteName:"Total",
        bookingBooked: list.map(item => item.bookingBooked).reduce(this.sum, 0),
        cancelBookingPrice: list.map(item => item.cancelBookingPrice).reduce(this.sum, 0),
        optionFailedPrice: list.map(item => item.optionFailedPrice).reduce(this.sum, 0),
        requestCancelled: list.map(item => item.requestCancelled).reduce(this.sum, 0),
        option: list.map(item => item.option).reduce(this.sum, 0),
        siteId: 99
      }
    },


    getTooltipPeriod(duration) {
      if (this.items.length > 0) {
        if (duration == 'day') {

          return `Le ${this._formatDate(new Date(this.items[0][duration].startPeriod), 'dd MMM yyyy')}
           comparé au ${this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'dd MMM yyyy')}`


        } else {
          return `
                Période du ${this._formatDate(new Date(this.items[0][duration].startPeriod), ' EEE dd MMM')}
                au ${this._formatDate(new Date(this.items[0][duration].endPeriod), 'EEE dd MMM yyyy')}, <br/>
                par rapport au ${this._formatDate(new Date(this.items[0][duration].oldStartPeriod), 'EEE dd MMM')}
                jusqu'au ${this._formatDate(new Date(this.items[0][duration].oldEndPeriod), 'EEE dd MMM yyyy')}`

        }
      } else {
        return 'pas de données'
      }
    },

  },

}
</script>


